import { useTheme } from '../contexts/ThemeContext';

/**
 * Full Orboto brand lockup (cyan dot + "rboto" wordmark). The wordmark
 * text colour follows light/dark mode via the `_white` asset variant.
 * The cyan dot is identical in both.
 *
 * Use this where the brand name should appear as a single styled image
 * (login hero, navbar). Use `<OrbotoLogo>` for tight square spaces.
 */
interface Props {
  /** Tailwind size + spacing. Original SVG aspect ratio is ~5:1. */
  className?: string;
}

export function OrbotoLockup({ className = 'h-8' }: Props) {
  const { resolvedTheme } = useTheme();
  const src = resolvedTheme === 'dark'
    ? '/logo_orboto_dot_white.svg'
    : '/logo_orboto_dot.svg';
  return <img src={src} alt="orboto" className={className} draggable={false} />;
}
